import { useEffect } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { useUserAuth } from '../state/userAuthContext';
import { catalogueRoutes } from './allRoutes';
import useFiltersState from '../state/useFiltersState';

const switchRoutes = (
  <Switch>
    {catalogueRoutes.map((prop, key) => {
      if (prop.layout === 'catalog') {
        return <Route path={`/${prop.layout}${prop.path}`} component={prop.component} key={key} exact />;
      }
      return null;
    })}
    <Redirect from="/catalog" to="/catalog/product-list" />
  </Switch>
);

const Catalogue = () => {
  const { user } = useUserAuth();
  const { setCatalogueFilters, setCatalogueSearchbarText } = useFiltersState();

  useEffect(() => {
    return () => {
      setCatalogueFilters([]);
      setCatalogueSearchbarText('');
    };
  }, []);

  return <> {user && switchRoutes} </>;
};

export default Catalogue;
